import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.function.name.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.seal.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapGetters } from 'vuex';
export default {
  name: 'ProductSheetTcVars',
  props: {
    product: {
      type: Object,
      required: true
    },
    urlBuilder: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      tcVars: Object.seal({
        env_country: '',
        env_language: '',
        env_template: 'page produit',
        page_url: this.$route.path,
        product_activity: '',
        cross_selling: '',
        earlybirds: '',
        earlybirds_widgets: '',
        earlybirds_xsell_similaire: '',
        earlybirds_xsell_complementaire: '',
        has_video: '',
        is_presto: '',
        product_currency: '',
        product_id: '',
        product_style: '',
        product_name: '',
        product_totalprice_ati: '',
        product_unitprice_ati: '',
        product_unit_price_ati_without_discount: '',
        product_unit_price_tf: '',
        product_unit_price_tf_without_discount: '',
        product_url_picture: '',
        product_label: '',
        product_isbundle: '',
        stock_availability_delay: '',
        variante: '',
        product_instock: '',
        presto_nb: '',
        is_product_collect: '',
        page_cat1: '',
        page_cat2: '',
        page_cat3: '',
        page_cat4: '',
        page_cat5: '',
        product_brand: '',
        ga_activated: 1,
        Product_list: '',
        user_email: '',
        user_id: '',
        user_firstorder_date: '',
        user_firstvisit_date: '',
        user_category: '',
        user_logged: false,
        user_gender: '',
        user_postalcode: '',
        user_subscription_newsletter: '',
        user_authentification: '',
        product_seller: ''
      })
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    user: 'user/me'
  })),
  created: function created() {
    var _this = this;

    this.setTcVars('init product sheet');
    this.$watch('product', function () {
      _this.setTcVars('product sheet reset tcVars');
    });
    this.$root.$on('reset-tcvars', function () {
      _this.setTcVars('product sheet reset tcVars');
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('reset-tcvars');
    this.$root.$off('fnClickTracking');
    this.$root.$off('fnClickTrackingVariant');
  },
  methods: {
    setTcVars: function setTcVars(message) {
      var _this$product = this.product,
          slug = _this$product.slug,
          reference = _this$product.reference,
          isMarketplace = _this$product.marketplace;
      var productType = this.product.type || '';

      if (isMarketplace) {
        this.tcVars.product_activity = 'Marketplace';
      } else {
        this.tcVars.product_activity = productType === 'DECORATION' ? 'Décoration' : "".concat(productType && productType[0].toUpperCase()).concat(productType.slice(1).toLowerCase());
      }

      if (process.client) {
        this.setCrossWidget('similar');
        this.setCrossWidget('complementary');
      }

      this.tcVars.env_country = this.locale.market;
      this.tcVars.env_language = this.locale.language;
      this.tcVars.page_url = this.urlBuilder.buildProductUrl(this.locale, slug, reference);
      this.tcVars.has_video = this.product.additionalInformation.video.length;
      this.tcVars.is_presto = '';
      this.tcVars.product_currency = this.locale.currency;
      this.tcVars.product_id = this.product.reference;
      this.tcVars.product_style = '';
      this.tcVars.product_name = this.product.name;
      this.tcVars.product_totalprice_ati = this.product.price.base.amount;
      this.tcVars.product_unitprice_ati = this.product.price.unit.amount;
      this.tcVars.product_unit_price_ati_without_discount = '';
      this.tcVars.product_unit_price_tf = '';
      this.tcVars.product_unit_price_tf_without_discount = '';
      this.tcVars.product_url_picture = '';
      this.tcVars.product_label = this.product.product_label;
      this.tcVars.product_isbundle = '';
      this.tcVars.stock_availability_delay = this.product.stock.waiting_delay;
      this.tcVars.variante = '';
      this.tcVars.product_instock = this.product.stock.state;
      this.tcVars.presto_nb = '';
      this.tcVars.is_product_collect = '';
      this.tcVars.product_brand = this.product.brand;
      this.tcVars.Product_list = '';
      this.tcVars.product_seller = this.product.offer && this.product.offer.merchant ? this.product.offer.merchant.name : '';
      var breadcrumb = this.product.additionalInformation.breadcrumbDisplay.map(function (item) {
        return item.label;
      });
      breadcrumb.shift();
      breadcrumb.pop();

      while (breadcrumb.length < 5) {
        breadcrumb.push('');
      }

      var _breadcrumb = _slicedToArray(breadcrumb, 5);

      this.tcVars.page_cat1 = _breadcrumb[0];
      this.tcVars.page_cat2 = _breadcrumb[1];
      this.tcVars.page_cat3 = _breadcrumb[2];
      this.tcVars.page_cat4 = _breadcrumb[3];
      this.tcVars.page_cat5 = _breadcrumb[4];

      if (process.client && window.ga === undefined) {
        this.tcVars.ga_activated = 0;
      }

      this.tcVars.user_logged = Boolean(this.user);

      if (this.user && process.client) {
        this.tcVars.user_email = window.localStorage.getItem('MDM_MAIL') || '';
        this.tcVars.user_id = this.user.id;
        this.tcVars.user_firstorder_date = '';
        this.tcVars.user_gender = this.user.civility;
        this.tcVars.user_postalcode = '';
        this.tcVars.user_subscription_newsletter = '';
        this.tcVars.user_authentification = window.localStorage.getItem('MDM_USER_AUTHENTIFICATION') || '';
        this.tcVars.user_category = this.$cookies.get('MDM[statut]') || this.user.type || '';
        this.tcVars.user_firstvisit_date = this.$cookies.get('MDM[date_first_visit]');
      }

      if (process.client && this.$cookies.get('debugmdm')) {
        this.$logger.debug(message, _objectSpread({}, this.tcVars));
      }

      this.$root.$emit('updated-tcvars', this.tcVars);
    },
    setCrossWidget: function setCrossWidget(widgetType) {
      var cross = widgetType === 'similar' ? this.product.cross : this.product.complementary;

      try {
        var widgetId = cross && cross.earlybirdsWidgets ? cross.earlybirdsWidgets.widgetId : null;
        var earlybirdsWidgets = JSON.parse(localStorage.getItem('EARLYBIRDS_WIDGETS')) || {};

        if (widgetId) {
          Object.assign(earlybirdsWidgets, _defineProperty({}, widgetId, cross.earlybirdsWidgets));
          localStorage.setItem('EARLYBIRDS_WIDGETS', JSON.stringify(earlybirdsWidgets));
          this.tcVars.earlybirds_widgets = earlybirdsWidgets;
          if (widgetType === 'similar') this.tcVars.earlybirds_xsell_similaire = widgetId;else if (widgetType === 'complementary') this.tcVars.earlybirds_xsell_complementaire = widgetId;
        }
      } catch (error) {
        this.$logger.error(error);
      }
    }
  },
  render: function render(h) {
    return h(null);
  }
};